'use client';

import { useState, useEffect } from 'react';
import Link from 'next/link';

export function CookieBanner() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Verifica se o usuário já aceitou os cookies anteriormente
    const consent = localStorage.getItem('nexussafe_cookie_consent');
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('nexussafe_cookie_consent', 'true');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-gray-900 border-t border-gray-800 text-white p-4 sm:p-6 z-[99999] shadow-2xl animate-in slide-in-from-bottom">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-sm font-medium text-gray-300 flex-1 leading-relaxed text-center sm:text-left">
          Nós utilizamos cookies essenciais e tecnologias semelhantes para garantir o funcionamento da plataforma e melhorar sua experiência. 
          Ao continuar navegando, você concorda com a nossa{' '}
          <Link href="/site/privacidade" className="text-blue-400 hover:text-blue-300 underline font-bold">
            Política de Privacidade
          </Link> e{' '}
          <Link href="/site/cookies" className="text-blue-400 hover:text-blue-300 underline font-bold">
            Política de Cookies
          </Link>.
        </p>
        <button 
          onClick={acceptCookies}
          className="bg-blue-600 hover:bg-blue-500 text-white px-8 py-3 rounded-xl font-black text-xs uppercase tracking-widest transition-colors w-full sm:w-auto shrink-0 shadow-lg"
        >
          Prosseguir e Aceitar
        </button>
      </div>
    </div>
  );
}